import { useIsMobile } from "../../helpers/ui";
import { Card } from "../../pages/ESA/Employee/Account/components";
import { colors } from "../../styles";
import { SectionFlexColumn } from "../General";
import T from "../Typography";
import PageContent from "./PageContent";

const ResponsePageContent = ({
  children,
  title,
  subtitle,
}: {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}) => {
  const isMobile = useIsMobile();
  return (
    <PageContent
      customStyles={
        !isMobile ? { display: "flex", justifyContent: "center" } : undefined
      }
    >
      <SectionFlexColumn
        sx={
          !isMobile
            ? { width: "752px", maxWidth: "752px", minHeight: "342px" }
            : undefined
        }
      >
        <div
          style={{
            marginTop: isMobile ? "0" : "32px",
            paddingBottom: "64px",
          }}
        >
          {!isMobile && (
            <>
              <T variant="headingMd">{title}</T>
              {subtitle && (
                <T variant="lgMed" color={colors.gray_600}>
                  {subtitle}
                </T>
              )}
            </>
          )}
          <Card hideStyleOnMobile>{children}</Card>
        </div>
      </SectionFlexColumn>
    </PageContent>
  );
};

export default ResponsePageContent;
